import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "filter-container" }
const _hoisted_2 = { class: "list-container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterSuiviFacture = _resolveComponent("FilterSuiviFacture")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FilterSuiviFacture, {
        onSearch: _ctx.search,
        onClearFilter: _ctx.clearFilter,
        onSetSociete: _ctx.setSociete,
        onSetEtablissement: _ctx.setEtablissement,
        onSetFournisseur: _ctx.setFournisseur,
        onSetNumeroFacture: _ctx.setNumeroFacture,
        onSetDateFrom: _ctx.setDateFrom,
        onSetDateTo: _ctx.setDateTo,
        onComparison: _ctx.setComparison,
        onSetMontant: _ctx.setMontant,
        filter: _ctx.filter,
        comparisonList: _ctx.comparisonList
      }, null, 8, ["onSearch", "onClearFilter", "onSetSociete", "onSetEtablissement", "onSetFournisseur", "onSetNumeroFacture", "onSetDateFrom", "onSetDateTo", "onComparison", "onSetMontant", "filter", "comparisonList"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        (_ctx.count > 0 && !_ctx.isFilterLoading && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('facture.payee.title', { count: +_ctx.count })), 1))
          : (_ctx.isFilterLoading && _ctx.tableData.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createVNode(_component_LoaderComponent)
              ]))
            : _createCommentVNode("", true),
        _createVNode(_component_ReglePastille, { cle: "facturation.perimetreChantiers" }),
        _createVNode(_component_ReglePastille, { cle: "facturation.defilementInfini" }),
        _createVNode(_component_ReglePastille, { cle: "facturation.triLocal" })
      ]),
      _createElementVNode("div", {
        onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
        ref: "content",
        class: "datatable"
      }, [
        (_ctx.isLoading && _ctx.tableData.length === 0)
          ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
          : (_openBlock(), _createBlock(_component_DataTable, {
              key: 1,
              count: +_ctx.count,
              tableHeader: _ctx.tableHeader,
              tableData: _ctx.tableData || [],
              isLoading: _ctx.isLoading,
              noDataText: _ctx.$t('facture.payee.noData'),
              "stop-propa-on-pdf": true,
              onDownloadPdf: _ctx.downloadPdf,
              onSelect: _ctx.downloadPdf,
              onSort: _ctx.handleSort
            }, null, 8, ["count", "tableHeader", "tableData", "isLoading", "noDataText", "onDownloadPdf", "onSelect", "onSort"]))
      ], 544)
    ])
  ], 64))
}